import { Inject, Injectable, Optional } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { AuthService } from '../auth/auth.service';
import get_permissions_for_resource from './graphql/user-permissions-request';
import get_permissions_for_resource_batch from './graphql/user-permissions-request';
import { BehaviorSubject, Observable } from 'rxjs';
import { User } from '../interfaces/user';

@Injectable({
  providedIn: 'root',
})
export class UserPermissionsService {
  public userPerms: any = {};
  running: boolean = false;
  private permsBehavior: BehaviorSubject<any> = new BehaviorSubject<any>(
    this.userPerms
  );
  public $userPerms: Observable<any> = this.permsBehavior.asObservable();

  constructor(private apollo: Apollo, private auth: AuthService) {
    this.apollo = apollo;
  }

  getUserPermissionsBatch(batch: any) {
    for(let i = 0; i < batch.length; i += 1) {
      if(!this.userPerms[batch[i].resourceType]) {
        this.userPerms[batch[i].resourceType] = [];
      }
      if(!this.userPerms[batch[i].resourceType][batch[i].resourceId]) {
        this.userPerms[batch[i].resourceType][batch[i].resourceId] = true;
      }
    }
    let query = this.apollo.watchQuery<any>({
      query: get_permissions_for_resource.get_permissions_for_resource_batch,
      variables: {
        requestedPerms: batch,
      },
    });
    let sub = query.valueChanges.subscribe(({ data }) => {
      if(data){
        for(let i = 0; i < batch.length; i += 1) {
          this.userPerms[batch[i].resourceType][batch[i].resourceId] = data.me.permissionsForResourceBatch[i];
        }
      }
    });
  }


  getUserPermissions(resourceType: string, resourceId: string | null) {
    let resourceKey = '_';
    if (resourceId) {
      resourceKey = resourceId;
    }

    if (
      !this.userPerms[resourceType] ||
      !this.userPerms[resourceType][resourceKey]
    ) {
      if (!this.userPerms[resourceType]) {
        this.userPerms[resourceType] = {};
      }
      if (!this.userPerms[resourceType][resourceKey]) {
        this.userPerms[resourceType][resourceKey] = true;
      }
      let query;
      query = this.getUserSpecificPermissions(resourceType, resourceId);
      if (query) {
        let sub = query.valueChanges.subscribe(({ data }) => {
          if(data){
            this.userPerms[resourceType][resourceKey] =
              data.me.permissionsForResource;
            this.permsBehavior.next(this.userPerms);
            sub.unsubscribe();
            return data.me.permissionsForResource;
          }
        });
      }
    } else {
      if (
        this.userPerms[resourceType][resourceKey] &&
        this.userPerms[resourceType][resourceKey] !== true
      ) {
        return this.userPerms[resourceType][resourceKey];
      }
    }
  }
  private getUserSpecificPermissions(
    resourceType: String,
    resourceId: String | null
  ) {
    return this.apollo.watchQuery<any>({
      query: get_permissions_for_resource.get_permissions_for_resource,
      variables: {
        resourceType: resourceType,
        resourceId: resourceId,
      },
    });
  }
}
